module.exports = __webpack_public_path__ + "76ec170141e7f5d69037d9c55309926b.png";